import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { Config, Id } from '../../config';
import { Chip } from './chip';
import { Empty } from './empty';
import css from './table.module.scss';
interface Props {
  section: Config[Id];
  onSelect(id: Id): void;
}
export function Table(t0) {
  const $ = _c(15);
  const {
    section,
    onSelect
  } = t0;
  const {
    label,
    data,
    issues
  } = section;
  let t1;
  if ($[0] !== label) {
    t1 = <span>{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Value</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={css.header}>{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data || $[6] !== issues || $[7] !== onSelect) {
    t4 = <ul className={css.list}>{Array.from(data.entries()).map(t5 => {
        const [key, value] = t5;
        const issue = issues?.get(key);
        return <li key={key} className={cn(css.item, {
          [css.warning]: issue?.severity === "warning",
          [css.error]: issue?.severity === "error"
        })}><span className={css.name}>{issue && <Chip issue={issue} />}<span>{key}</span></span>{key === "x-petm-decisions" ? <button type="button" className={css.link} onClick={() => onSelect("flags")}>View feature flags ›</button> : <span className={css.value}>{value}</span>}</li>;
      })}</ul>;
    $[5] = data;
    $[6] = issues;
    $[7] = onSelect;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== data.size) {
    t5 = data.size === 0 && <Empty />;
    $[9] = data.size;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}